import { apiRequest } from "../lib/apiClient";
import type { LoyaltyAccountOut, TenantLoyaltySettingsOut, TenantLoyaltySettingsUpdate } from "./types";

/** `GET /loyalty/customers/{id}` — get-or-create semantics (a customer with no account
 * yet gets a 0-balance one created on the fly, not a 404). Read-only route — earning/
 * redemption only happen via `POST /sales`. */
export async function getLoyaltyAccount(accessToken: string, customerId: string): Promise<LoyaltyAccountOut> {
  return apiRequest<LoyaltyAccountOut>(`/loyalty/customers/${customerId}`, { accessToken });
}

/** `GET /tenant-settings/loyalty` — any authenticated user. */
export async function getLoyaltySettings(accessToken: string): Promise<TenantLoyaltySettingsOut> {
  return apiRequest<TenantLoyaltySettingsOut>("/tenant-settings/loyalty", { accessToken });
}

/** `PATCH /tenant-settings/loyalty` — OWNER only. */
export async function updateLoyaltySettings(
  accessToken: string,
  body: TenantLoyaltySettingsUpdate,
): Promise<TenantLoyaltySettingsOut> {
  return apiRequest<TenantLoyaltySettingsOut>("/tenant-settings/loyalty", { method: "PATCH", accessToken, body });
}
